var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9266 25.953L23.4675 21.4121C26.0617 18.8178 26.4754 14.7238 24.4576 11.6864C23.9332 10.8668 23.0641 10.0015 22.2659 9.49077C19.2177 7.46613 15.1237 7.87979 12.5295 10.474L7.98853 15.015L18.9266 25.953Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0236 27.039L6.90241 15.9177C6.11902 16.2893 5.15541 16.1595 4.50807 15.5121L3.5137 16.5065L17.4349 30.4277L18.4292 29.4333C17.7819 28.786 17.6521 27.8224 18.0236 27.039Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0436 8.31864C23.5014 8.61237 23.9977 9.01731 24.4589 9.47856C24.9231 9.94273 25.3324 10.4443 25.6422 10.9288C25.6808 10.987 25.7035 11.0513 25.7406 11.1101C26.2612 10.2942 26.1681 9.19712 25.4562 8.48516C24.7436 7.77259 23.645 7.67985 22.829 8.20196C22.8987 8.24562 22.9747 8.27293 23.0436 8.31864Z",
    fill: "#4B9BF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.08008 23.0614C7.70855 23.8448 7.83835 24.8084 8.48568 25.4557C9.13302 26.103 10.0966 26.2328 10.88 25.8613L8.08008 23.0614Z",
    fill: "#4B9BF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16.9707) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.c4280ba291de312e090d7aaf51ecf36b.svg";
export { ForwardRef as ReactComponent };